//Built-in libraries

//Third party libraries

//Custom components
import Button from 'components/UI/Button';

//Services
import { useApplicationFormContext } from 'features/ApplicationForm/ApplicationFormProvider';

//STP Libraries

//Assets and Miscellaneous

import { HookFileInput } from 'components/UI/HookForm/Form/File';
import { useFormContext } from 'react-hook-form';
import { ISignApplicationPublicAssetPayload } from 'api/Rover/ApplicationForm/types';
import { SignedApplicationAssetResponse } from 'types/Shared';
import { useFileUpload } from 'hooks/useFileUpload';
import { signApplicationPublicAsset } from 'api/Rover/ApplicationForm';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';

//Component Begin

export default function Attachments() {
  const [uploadError, setUploadError] = useState<string>('');
  const { setCurrentStep, updateData } = useApplicationFormContext();
  const {
    trigger,
    getValues,
    formState: { errors, isValid },
  } = useFormContext();

  const { upload } = useFileUpload({
    signAsset: signApplicationPublicAsset,
  });

  const uploadFile = useMutation(
    (
      payloads: {
        signAssetPayload: ISignApplicationPublicAssetPayload[];
        files: File[];
        field: { key: string; description: string };
      }[]
    ) => Promise.allSettled(payloads.map((p: any) => upload(p))),
    {
      onSuccess: (
        res: any[],
        payloads: {
          signAssetPayload: ISignApplicationPublicAssetPayload[];
          files: File[];
          field: { key: string; description: string };
        }[]
      ) => {
        res.forEach((r, resIndex) => {
          const { files, sign } = r.value;
          let signRes: SignedApplicationAssetResponse[] = [];

          if (Array.isArray(sign)) {
            signRes = [...sign];
          } else {
            signRes = [{ ...sign }];
          }

          updateData({
            attachments: {
              ...getValues('attachments'),
              [payloads[resIndex].field.key]: {
                ...getValues('attachments')[payloads[resIndex].field.key],
                selectedFiles: signRes.map((sig, index) => ({
                  name: files[index].name,
                  path: sig.path,
                  key: sig.key,
                  type: files[index].type,
                  field: payloads[resIndex].field.key,
                  description: payloads[resIndex].field.description,
                })),
              },
            },
          });
        });
        setCurrentStep((prev) => prev + 1);
      },

      onError: (error: any) => {
        setUploadError('Failed to upload');
      },
    }
  );

  const onSubmit = async () => {
    trigger();
    if (!isValid) {
      return;
    }
    const formData = getValues('attachments');

    //TO DO: Enable file upload
    // const fileUploadPayload = buildFileUploadPayload();
    // if (fileUploadPayload.length > 0) {
    //   uploadFile.mutate(fileUploadPayload);
    // } else {
    //   updateData({
    //     attachments: { ...formData },
    //   });
    //   setCurrentStep((prev) => prev + 1);
    // }
    updateData({
      attachments: { ...formData },
    });
    setCurrentStep((prev) => prev + 1);
  };

  return (
    <div className="sm:rounded-r-md sm:overflow-hidden">
      <div className="py-6 px-4 space-y-6 sm:p-6">
        <h3 className="text-lg leading-6 font-medium text-green-500">
          Attachments
        </h3>
        <div className="my-5">
          <h4>Please provide the following documents.</h4>
        </div>
        <HookFileInput
          name="attachments.approvalLetter"
          accept=".pdf"
          label="1st Mortgage Pre-Approval Letter"
          multiple
        />
        <HookFileInput
          name="attachments.taxReturn"
          label="Most Recent Tax Return"
          multiple
        />
        <HookFileInput
          name="attachments.payStubs"
          label="Two Months of Most Recent Pay Stubs"
          multiple
        />
        <HookFileInput
          name="attachments.bankStatements"
          label="3 Months of Bank Statements"
          multiple
        />
        <div className="flex gap-4 justify-end mt-5">
          <Button
            label="Previous"
            btnStyle="neutral"
            type="button"
            onClick={() => setCurrentStep((prev) => prev - 1)}
          />
          <Button
            label={uploadFile.isLoading ? 'Uploading Files...' : 'Next'}
            btnStyle={uploadFile?.isLoading ? 'neutral' : 'primary'}
            disabled={uploadFile.isLoading}
            type="button"
            onClick={onSubmit}
          />
        </div>
      </div>
    </div>
  );
}
